import { SECTION_IDS, SECTION_THEMES, useScrollspy } from "../lib/scrollspy";

export const ThemeBackground = () => {
  const active = useScrollspy(SECTION_IDS);
  return (
    <div
      aria-hidden="true"
      data-testid="theme-background"
      data-theme={active}
      className="theme-bg"
      style={{ backgroundColor: SECTION_THEMES[active] || "#050607" }}
    />
  );
};
